module.exports = function setupWebsocket(opts) {
    let wsRedisPub = null;
    let wsRedisSub = null;

    if (opts.ws && opts.ws.redisUrl) {
        try {
            const { createClient } = require('redis');
            wsRedisPub = createClient({ url: opts.ws.redisUrl });
            wsRedisSub = createClient({ url: opts.ws.redisUrl });

            wsRedisPub.on('error', (e) => console.error('[fullstx] WS Redis Pub Error:', e));
            wsRedisSub.on('error', (e) => console.error('[fullstx] WS Redis Sub Error:', e));

            wsRedisPub.connect().catch(() => {});
            wsRedisSub
                .connect()
                .then(() => {
                    console.log('[fullstx] WebSocket Redis Pub/Sub Adapter enabled.');
                })
                .catch(() => {});
        } catch {
            console.error('[fullstx] Failed to load redis for WS Pub/Sub');
        }
    }

    return { wsRedisPub, wsRedisSub };
};
